import { Link, useLocation } from "@tanstack/react-router";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
} from "~/components/ui/card";

export function AboutCard() {
  const location = useLocation();

  // Detect current language from path
  const getLanguage = () => {
    const segments = location.pathname.split("/").filter(Boolean);
    const langs = ["uz", "ru", "en"];
    return langs.includes(segments[0]) ? segments[0] : "oz";
  };

  // Get internal page path preserving language
  const getPagePath = (page: string) => {
    const lang = getLanguage();
    return lang === "oz" ? `/${page}` : `/${lang}/${page}`;
  };

  // Multi-language content
  const content = {
    "uz-Latn": {
      title: "Lotin.uz loyihasi haqida",
      paragraphs: [
        "Lotin.uz sayti orqali siz so'zlarni o'zbek kirill yozuvidan o'zbek lotin yozuviga o'tkazishingiz mumkin.",
        "Lotin.uz — foydalanuvchilarga berilgan matnni kirilldan lotinga va aksincha o'girish xizmatini taklif etadi. Bir so'z bilan aytganda lotinni kirillga, va kirillni lotinga o'girish programmasi deb atasak ham bo'ladi.",
      ],
      contact: {
        text: "Loyihani rivojlantirish bo'yicha taklif va fikrlaringizni ",
        linkText: "Telegramga",
        postText: " yozing.",
      },
      social: {
        text: "Lotin.uz saytining ijtimoiy tarmoqlarda ham kanal va sahifalari bor. Jumladan ",
        platforms: "ijtimoiy tarmoqlarda kuzatishingiz mumkin.",
      },
      disclaimer:
        "Shuningdek, seks, porno, zo'ravonlik, 18+ sahifalarga mutloq qarshimiz. Yoshlar orasida erotika va pornografiya tarqalishiga qarshi olib borilayotgan muxim chora-tadbirlarni to'liq qo'llab quvvatlaymiz.",
      readMore: "Batafsil Lotin.uz loyihasi haqida →",
    },
    "uz-Cyrl": {
      title: "Lotin.uz лойиҳаси ҳақида",
      paragraphs: [
        "Lotin.uz сайти орқали сиз сўзларни ўзбек кирилл ёзувидан ўзбек лотин ёзувига ўтказишингиз мумкин.",
        "Lotin.uz — фойдаланувчиларга берилган матнни кириллдан лотинга ва аксинча ўгириш хизматини таклиф этади. Бир сўз билан айтганда лотинни кириллга, ва кириллни лотинга ўгириш программаси деб атасак ҳам бўлади.",
      ],
      contact: {
        text: "Лойиҳани ривожлантириш бўйича таклиф ва фикрларингизни ",
        linkText: "Телеграмга",
        postText: " ёзинг.",
      },
      social: {
        text: "Lotin.uz сайтининг ижтимоий тармоқларда ҳам канал ва саҳифалари бор. Жумладан ",
        platforms: "ижтимоий тармоқларда кузатишингиз мумкин.",
      },
      disclaimer:
        "Шунингдек, секс, порно, зўравонлик, 18+ саҳифаларга мутлоқ қаршимиз. Ёшлар орасида эротика ва порнография тарқалишига қарши олиб борилаётган муҳим чора-тадбирларни тўлиқ қўллаб қувватлаймиз.",
      readMore: "Батафсил Lotin.uz лойиҳаси ҳақида →",
    },
    ru: {
      title: "О проекте Lotin.uz",
      paragraphs: [
        "С помощью сайта Lotin.uz вы можете конвертировать текст с узбекской кириллицы на узбекскую латиницу.",
        "Lotin.uz — предлагает пользователям услугу конвертации текста с кириллицы на латиницу и наоборот. Простыми словами, это программа для конвертации латиницы в кириллицу и кириллицы в латиницу.",
      ],
      contact: {
        text: "Отправьте свои предложения и идеи по развитию проекта в ",
        linkText: "Telegram",
        postText: ".",
      },
      social: {
        text: "Сайт Lotin.uz также присутствует в социальных сетях. Вы можете подписаться на ",
        platforms: "следующие страницы в социальных сетях.",
      },
      disclaimer:
        "Также мы категорически против контента для взрослых, порно, насилия, страниц 18+. Мы полностью поддерживаем важные меры, предпринимаемые против распространения эротики и порнографии среди молодежи.",
      readMore: "Подробнее о проекте Lotin.uz →",
    },
    "en-US": {
      title: "About Lotin.uz Project",
      paragraphs: [
        "Through Lotin.uz website, you can convert text from Uzbek Cyrillic to Uzbek Latin script.",
        "Lotin.uz — offers users a service to convert text from Cyrillic to Latin and vice versa. In simple terms, it's a program for converting Latin to Cyrillic and Cyrillic to Latin.",
      ],
      contact: {
        text: "Send your suggestions and ideas for project development via ",
        linkText: "Telegram",
        postText: ".",
      },
      social: {
        text: "Lotin.uz website also has channels and pages on social networks. You can follow on ",
        platforms: "these social networks.",
      },
      disclaimer:
        "Additionally, we are strongly against adult content, pornography, violence, and 18+ pages. We fully support important measures being taken against the spread of erotica and pornography among young people.",
      readMore: "More about Lotin.uz project →",
    },
  };

  const langMap: Record<string, keyof typeof content> = {
    oz: "uz-Latn",
    uz: "uz-Cyrl",
    ru: "ru",
    en: "en-US",
  };

  const currentLang = getLanguage();
  const currentContent = content[langMap[currentLang]] || content["uz-Latn"];

  return (
    <Card className="shrink-0">
      <CardHeader>
        <CardTitle>{currentContent.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-3">
          {currentContent.paragraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}

          <p>
            {currentContent.contact.text}
            <a
              href="https://t.me/ObunaContact"
              className="font-medium "
              target="_blank"
              rel="noopener noreferrer"
            >
              {currentContent.contact.linkText}
            </a>
            {currentContent.contact.postText}
          </p>

          <p>
            {currentContent.social.text}
            <a
              href="https://t.me/lotin_kirill"
              className="font-medium "
              target="_blank"
              rel="noopener noreferrer"
            >
              Telegram
            </a>
            ,{" "}
            <a
              href="https://www.instagram.com/lotinuz/"
              className="font-medium "
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
            ,{" "}
            <a
              href="https://www.facebook.com/lotinuz"
              className="font-medium "
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
            ,{" "}
            <a
              href="https://twitter.com/lotinuz"
              className="font-medium "
              target="_blank"
              rel="noopener noreferrer"
            >
              Twitter
            </a>{" "}
            {currentContent.social.platforms}
          </p>

          <p>{currentContent.disclaimer}</p>
        </div>
      </CardContent>
      <CardFooter>
        <Link to={getPagePath("about")} className="font-medium">
          {currentContent.readMore}
        </Link>
      </CardFooter>
    </Card>
  );
}
